import React from 'react';
import { useTranslation } from 'gatsby-plugin-react-i18next';
import styled from 'styled-components';
import { BLOOD_DROPLET_ICON } from '@constants';

interface DropletIconsProps {
  dropsCount: number;
}

const DropletIcons: React.FC<DropletIconsProps> = ({ dropsCount }) => {
  const { t } = useTranslation();
  return (
    <DropletIconsWrapper>
      {Array.from({ length: dropsCount }, (_, index) => (
        <img key={index} src={BLOOD_DROPLET_ICON} alt={t('components.blood-droplet')} />
      ))}
    </DropletIconsWrapper>
  );
};

export default DropletIcons;

const DropletIconsWrapper = styled.div`
  display: flex;
  gap: 4px;
  justify-content: center;
`;
